export default {
  DARK: {
    border: () => 'none',
    shadow: () => 'none',
    buttonShadow: () => 'none',
    raisedShadow: () => 'none',
    anchor: p => p.primaryLight,
    heading: p => p.accentWhite,
    paragraph: p => p.accentWhite,
    blockText: p => p.tertiaryNormal,
    background: p => p.tertiaryDark,
    lightBackground: p => p.tertiaryExtraLight,

    backgroundColor: p => p.tertiaryDark
  },
  LIGHT: {
    anchor: p => p.primaryDark,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    blockText: p => p.tertiaryNormal,
    background: p => p.tertiaryLight,
    lightBackground: p => p.tertiaryExtraLight,

    backgroundColor: p => p.tertiaryLight
  },
  EXTRALIGHT: {
    anchor: p => p.primaryDark,
    heading: p => p.tertiaryDark,
    paragraph: p => p.tertiaryNormal,
    blockText: p => p.tertiaryNormal,
    background: p => p.tertiaryExtraLight,
    lightBackground: p => p.tertiaryExtraLight,
    backgroundColor: p => p.tertiaryExtraLight
  }
}
